import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NavMenuService } from '@app/core/components/nav-menu/nav-menu.service';
import { ApplicationInfoService } from '@app/core/services/application-info.service';
import { UserService } from '@app/core/services/user.service';
import { MessagesPanelService } from '@app/shared/services/messages.service';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';


@Component({
  selector: 'vp-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  imports: [
    NgClass,
    CollapseModule,
    AsyncPipe,
    RouterLink,
    RouterLinkActive,
    PopoverModule,
    TooltipModule
  ]
})
export class NavMenuComponent implements OnInit {
  private router = inject(Router);
  public userService = inject(UserService);
  private navMenuService = inject(NavMenuService);
  private applicationInfoService = inject(ApplicationInfoService);
  private messagesPanelService = inject(MessagesPanelService);

  isExpanded = false;
  unreadMessages$: Observable<number>;
  activeMessages$ = this.messagesPanelService.activeMessages$;
  applicationInfo$ = this.applicationInfoService.getApplicationInfo();
  sendNotification = true;
  private notificationSubject = new Subject<boolean>();

  isAdmin = () => this.userService.isAdmin();
  isVendorUser = () => this.userService.isVendorUser();
  collapse = () => this.isExpanded = false;
  toggle = () => this.isExpanded = !this.isExpanded;
  getNavClass = () => this.userService.isLoggedIn() ? 'navbar-expand-lg' : 'navbar-expand';
  getRocheLogoClass = () => this.userService.isLoggedIn() && this.isAdmin() ? 'd-lg-none d-xl-block' : '';
  switchNotification = () => this.notificationSubject.next(this.sendNotification = !this.sendNotification);
  logout = () => this.userService.logout().add(() => this.router.navigateByUrl('/login'));

  constructor() {
    this.unreadMessages$ = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd && this.userService.isLoggedIn()),
        debounceTime(0),
        switchMap(() => this.userService.isLoggedIn() ? this.navMenuService.getUnreadMessagesCount() : of(0)),
        shareReplay(1)
      );

    this.router.events
      .pipe(
        map(() => this.userService.isLoggedIn()),
        distinctUntilChanged(),
        switchMap(isLoggedIn => isLoggedIn ? this.userService.isNotificationEnabledForUser() : of(true)),
        tap(sendNotification => this.sendNotification = sendNotification)
      )
      .subscribe();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd && this.userService.isLoggedIn()),
        debounceTime(0),
        tap(() => {
          this.messagesPanelService.refreshActiveMessages();
          return true;
        }),
        shareReplay(1)
      )
      .subscribe();
  }

  ngOnInit() {
    this.notificationSubject
      .pipe(
        filter(() => this.userService.isLoggedIn()),
        debounceTime(150),
        distinctUntilChanged(),
        switchMap(enabled => this.userService.setNotification(enabled))
      )
      .subscribe();
  }
}
